<template>
    <div>
        <Box  @close="cerrar()">
            <template #top>{{ titulo }}</template>
            <template #center>
                <b-table :data="lista_asignacion_detalle" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                    aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                    <template slot-scope="props">
                        <b-table-column label="ID Asignación" header-class="is-info">{{ props.row.asi_id }}</b-table-column>
                        <b-table-column label="Fecha asignación" header-class="is-info">{{ props.row.asi_fecha_registro }}</b-table-column>
                        <b-table-column label="Solicitante" header-class="is-info">{{ props.row.emp_solicitante_nombre }}</b-table-column>
                        <b-table-column label="Autorizador" header-class="is-info">{{ props.row.emp_autorizador_nombre }}</b-table-column>
                        <b-table-column label="Item" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                        <b-table-column label="Cantidad asignada" header-class="is-info">{{ props.row.aid_cantidad }}</b-table-column>
                        <b-table-column label="Cantidad retornada" header-class="is-info">{{ props.row.did_cantidad_total }}</b-table-column>
                        <b-table-column label="Saldo" header-class="is-info">{{ props.row.aid_saldo }}</b-table-column>
                        <b-table-column label="Tiempo retorno (días)" header-class="is-info">{{ props.row.prv_retorno_estimado }}</b-table-column>
                    </template>
                </b-table>
            </template>
        </Box>
    </div>
</template>

<script>
import { AsignacionItemsService } from "../../services"
import Toast from "../../util/toast"
import { Box } from "../components"

export default {
    name: "HistorialAsignacionesxSolicitante",
    components: {
        Box,
    },
    props: {
        filters: {
            type: Object
        },
        titulo: {
            type: String
        }
    },
    data() {
        return {
            lista_asignacion_detalle: [],
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        cerrar() {
            this.$emit("close")
        },
        buscarAsignaciones() {
            this.lista_asignacion_detalle = []
            AsignacionItemsService.buscarDetalle(this.filters).then(
                response => {
                    this.lista_asignacion_detalle = response.data
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        }
    },
    mounted() {
        this.buscarAsignaciones()
    }
}
</script>

<style scoped></style>